import { render } from "./MdvLongArticle.vue?vue&type=template&id=e834bdea&scoped=true"
import script from "./MdvLongArticle.vue?vue&type=script&lang=js"
export * from "./MdvLongArticle.vue?vue&type=script&lang=js"

import "./MdvLongArticle.vue?vue&type=style&index=0&id=e834bdea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\mdv-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e834bdea"]])

export default __exports__